import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getColor from "@insite/mobius/utilities/getColor";
import { rfqQuoteDetailsMessagesStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsMessages";


rfqQuoteDetailsMessagesStyles.mainWrapper = mergeToNew(rfqQuoteDetailsMessagesStyles.mainWrapper, {
    css: css`
      display: flex;
      flex-direction: column;
      background-color: ${getColor("secondary")};
      padding: 10px 20px;
    `
});
